import { mapActions, mapGetters } from 'vuex';
import Empty from '@/components/@general/Empty/index.vue';
import OrderCard from '@/components/cards/OrderCard/index.vue';
import { globalLoader } from '@/helpers/variables';

export default {
  name: 'HistoryOrders',
  components: {
    Empty,
    OrderCard
  },
  data() {
    return {
      currentPage: 1,
      ordersList: [],
      isHasNextPage: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({})
  },
  created() {
    this._loadContent();
  },
  methods: {
    ...mapActions({
      getHistoryOrders: `profile/GET_HISTORY_ORDERS`
    }),
    _loadContent() {
      this.isLoading = true;
      if (this.$route.query.order) {
        this.getHistoryOrdersUntilFound({
          page: this.currentPage,
          orderId: this.$route.query.order,
          perPage: 15
        });
      } else {
        this.getHistoryOrders({ page: this.currentPage, perPage: 15 }).then((res) => {
          this.ordersList = res.data;
          this.isHasNextPage = !!res.links.next;
          this.isLoading = false;
          globalLoader(false);
        });
      }
    },
    getHistoryOrdersUntilFound({ page, orderId }) {
      return this.getHistoryOrders({ page, perPage: 50 }).then((res) => {
        this.ordersList = this.ordersList ? [...this.ordersList, ...res.data] : res.data;
        this.isHasNextPage = !!res.links.next;
        let isOrderFound = this.ordersList.some((item) => item.id === orderId);

        if (this.isHasNextPage && !isOrderFound) {
          return this.getHistoryOrdersUntilFound({ page: page + 1, orderId, perPage: 50 });
        } else {
          this.isLoading = false;
          globalLoader(false);
        }
      });
    },
    onLoadMore() {
      this.isLoading = true;
      this.currentPage++;
      this.getHistoryOrders({ page: this.currentPage }).then((res) => {
        this.ordersList = [...this.ordersList, ...res.data];
        this.isHasNextPage = !!res.links.next;
        this.isLoading = false;
      });
    }
  }
};
